import axios from 'axios';
import store from '@/store';
import router from '@/router';
import { gapSentryChannel } from '@/util/sentry';

const httpClient = axios.create(
  {
    baseURL: process.env.VUE_APP_GATEWAY_BASE_URL,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Pragma: 'no-cache'
    }
    // TODO: 큰 파일 업로드 시 문제가 발생해서 다시 시간 제한을 없앰. 일부에만 timeout 적용 혹은 일부에만 timeout 미적용 필요.
    // // axios 기본타임아웃이 0(무한대기)라서 어드민 게이트웨이 등이 종료 되었을 때 브라우저 기본 타임아웃만큼 (크롬은 5분)
    // // 기다려야 에러가 발생하는 오류가 있어서 타임아웃을 10초로 설정.
    // // 기존 5초 -> 10초 (sandbox pregs, sandbox kakao login 등 5초 이상 걸리는 api들이 있음)
    // timeout: 10000
  }
);

httpClient.interceptors.response.use(
  (response) => {
    if (response?.data?.success === false) {
      console.error(response);
    }
    return response;
  },
  (error) => {
    if (error?.response?.data?.code === "api.response.auth.notLogin") {
      console.log(router.currentRoute);
      if (router.currentRoute.path !== '/' &&
          router.currentRoute.path !== '/login/ldap') {
        alert("로그인 토큰이 만료되었습니다. 다시 로그인해주세요.").then(() => {
          store.commit('removeAuth');
        });
      } else {
        store.commit('removeAuth');
      }
    } else if (error?.response?.data?.code === "api.response.auth.page.exception") {
      alert("해당 페이지에 대한 권한이 없습니다.");
      const firstMenu = store.getters.getFirstMenu;
      if (firstMenu) {
        router.push(firstMenu.url);
      } else {
        store.dispatch("logout")
          .then(() => alert("접근할 수 있는 메뉴가 없습니다. 관리자에게 문의하세요"));
      }
    } else {
      if (error?.response?.status === 400) {
        alert(error?.response?.data?.msg ||
              error?.response?.data?.message ||
              "잘못된 요청입니다.");
      } else if (error?.response?.status === 401) {
        alert(error?.response?.data?.msg || "권한이 없습니다.");
      } else if (error?.response?.status === 404) {
        alert("존재하지 않는 API를 호출하였습니다.");
      } else if (error?.response?.status === 405) {
        alert("잘못된 호출입니다.");
      } else if (error?.response?.status >= 500) {
        if (error?.config?.headers?.skipAlert ||
            error?.response?.data?.message?.startsWith(
              'software.amazon.awssdk.services.s3.model.NoSuchKeyException')
        ) {
          console.log('서버에 오류가 발생했습니다.');
        } else {
          alert('서버에 오류가 발생했습니다.');
          gapSentryChannel.captureException(error);
        }
      } else if (!error?.response && error?.request) {
        if (error?.config?.headers?.skipAlert) {
          console.log("네트워크에 문제가 있습니다.");
        } else if (error?.code === "ECONNABORTED" && error?.message?.includes("timeout")){ // TIMEOUT
          alert('서버에 오류가 발생했습니다.');
          gapSentryChannel.captureException(error);
        } else {
          alert('네트워크에 문제가 있습니다.');
        }
      }
      console.log(error?.toJSON());
      return Promise.reject(error);
    }
  }
);

export default httpClient;
